class SadanRecentlyViewed extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.storageKey = this.dataset.storageKey || 'sadan-recently-viewed-v1';
    this.limit = Math.max(1, Number.parseInt(this.dataset.limit || '4', 10));
    this.maxStored = 12;

    const currentProduct = this.getCurrentProduct();
    const history = this.getHistory();
    const itemsToShow = history
      .filter((item) => item && item.handle && item.handle !== currentProduct?.handle)
      .slice(0, this.limit);

    if (itemsToShow.length) {
      this.render(itemsToShow);
      this.hidden = false;
    }

    if (currentProduct?.handle) this.saveCurrentProduct(currentProduct, history);
  }

  getCurrentProduct() {
    const source = this.querySelector('[data-current-product]');
    if (!source) return null;

    try {
      const product = JSON.parse(source.textContent);
      if (!product || typeof product !== 'object' || !product.handle) return null;
      return product;
    } catch (error) {
      return null;
    }
  }

  getHistory() {
    try {
      const value = JSON.parse(localStorage.getItem(this.storageKey) || '[]');
      if (!Array.isArray(value)) return [];
      return value.filter((item) => item && typeof item === 'object' && item.handle);
    } catch (error) {
      return [];
    }
  }

  saveCurrentProduct(currentProduct, history) {
    const nextHistory = [
      currentProduct,
      ...history.filter((item) => item.handle !== currentProduct.handle),
    ].slice(0, this.maxStored);

    try {
      localStorage.setItem(this.storageKey, JSON.stringify(nextHistory));
    } catch (error) {
      // Private browsing or browser settings can disable localStorage.
    }
  }

  render(products) {
    const grid = this.querySelector('[data-recently-viewed-grid]');
    if (!grid) return;

    const fragment = document.createDocumentFragment();
    products.forEach((product) => fragment.appendChild(this.buildCard(product)));
    grid.replaceChildren(fragment);
  }

  buildCard(product) {
    const item = document.createElement('li');
    item.className = 'sadan-recently-viewed__item';

    const card = document.createElement('article');
    card.className = 'sadan-recent-card';

    const link = document.createElement('a');
    link.className = 'sadan-recent-card__link';
    link.href = product.url || `/products/${encodeURIComponent(product.handle)}`;

    const media = document.createElement('div');
    media.className = 'sadan-recent-card__media';

    if (product.image) {
      const image = document.createElement('img');
      image.src = product.image;
      image.alt = product.title || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      image.width = 720;
      image.height = 900;
      media.appendChild(image);
    }

    const info = document.createElement('div');
    info.className = 'sadan-recent-card__info';

    const title = document.createElement('h3');
    title.className = 'sadan-recent-card__title';
    title.textContent = product.title || '';

    const price = document.createElement('div');
    price.className = 'sadan-recent-card__price';

    if (product.compareAtPrice) {
      const compare = document.createElement('span');
      compare.className = 'sadan-recent-card__compare';
      compare.textContent = product.compareAtPrice;
      price.appendChild(compare);
    }

    const currentPrice = document.createElement('span');
    currentPrice.textContent = product.price || '';
    price.appendChild(currentPrice);

    info.append(title, price);
    link.append(media, info);
    card.appendChild(link);
    item.appendChild(card);
    return item;
  }
}

if (!customElements.get('sadan-recently-viewed')) {
  customElements.define('sadan-recently-viewed', SadanRecentlyViewed);
}
